// Common translations used across all pages (nav, footer, contact basics)
export const commonTranslations = {
  en: {
    // Navigation
    'nav.home': 'Home',
    'nav.about': 'About',
    'nav.benefits': 'Benefits',
    'nav.drivers': 'Benefits & Support',
    'nav.cadastro': 'Driver Jobs',
    'nav.registo': 'Driver Registration',
    'nav.requisitos': 'Requirements',
    'nav.download': 'Download App',
    'nav.recarga': 'Top-Up',
    'nav.blog': 'Blog',
    'nav.coverage': 'Coverage',
    'nav.faq': 'FAQ',
    'nav.partners': 'Partners',
    'nav.contact': 'Contact',
    'nav.contactUs': 'Contact Us',
    'nav.testimonials': 'Testimonials',
    
    // Footer
    'footer.home': 'Home',
    'footer.about': 'About',
    'footer.blog': 'Blog',
    'footer.download': 'Download App',
    'footer.benefits': 'Benefits',
    'footer.services': 'Services',
    'footer.drivers': 'Driver Benefits',
    'footer.registo': 'Driver Registration',
    'footer.coverage': 'Coverage',
    'footer.faq': 'FAQ',
    'footer.partners': 'Partners',
    'footer.contact': 'Contact',
    'footer.testimonials': 'Testimonials',
    'footer.privacy': 'Privacy Policy',
    'footer.terms': 'Terms',
    'footer.language': 'Language',
    'footer.copyright': '© 2025 Kareem Taxi. All rights reserved.',
    'footer.viewOnGoogle': 'View us on Google',
    'footer.cadastro': 'Driver Registration',
    'footer.recarga': 'Automatic Top-Up',
    
    // Contact basics
    'contact.title': 'Contact Us',
    'contact.name': 'Name',
    'contact.email': 'Email',
    'contact.organization': 'Organization',
    'contact.subject': 'Subject',
    'contact.message': 'Message',
    'contact.submit': 'Send Message',
    'contact.success': 'Thanks! We\'ll reply by email.',
    'contact.emailLabel': 'Email',
    'contact.viewOnGoogle': 'View us on Google',
    
    // Partners
    'partners.title': 'Our Partners',
    'partners.subtitle': 'Partnerships build trust through results.',
    
    // 404 Page
    'notfound.intro': 'The page you are looking for does not exist or has been moved. Use the links below to find what you need:',
    'notfound.popularPages': 'Popular Pages',
    'notfound.searchSuggestion': 'If you are looking for information about Yango registration, driver requirements, or registration, explore the links above or contact our support team.',
    'notfound.needHelp': 'Need Help?',
    'notfound.contact': 'Contact our support team on WhatsApp',
  },
  pt: {
    // Navigation
    'nav.home': 'Início',
    'nav.about': 'Sobre',
    'nav.benefits': 'Benefícios',
    'nav.drivers': 'Benefícios & Suporte',
    'nav.cadastro': 'Vagas Motorista',
    'nav.registo': 'Registo Motorista',
    'nav.requisitos': 'Requisitos',
    'nav.download': 'Baixar App',
    'nav.recarga': 'Recarga',
    'nav.blog': 'Blog',
    'nav.coverage': 'Cobertura',
    'nav.faq': 'Perguntas',
    'nav.partners': 'Parceiros',
    'nav.contact': 'Contacto',
    'nav.contactUs': 'Falar Connosco',
    'nav.testimonials': 'Depoimentos',
    
    // Footer
    'footer.home': 'Início',
    'footer.about': 'Sobre',
    'footer.blog': 'Blog',
    'footer.download': 'Baixar App',
    'footer.benefits': 'Benefícios',
    'footer.services': 'Serviços',
    'footer.drivers': 'Benefícios Motorista',
    'footer.registo': 'Registo Motorista',
    'footer.coverage': 'Cobertura',
    'footer.faq': 'Perguntas',
    'footer.partners': 'Parceiros',
    'footer.contact': 'Contacto',
    'footer.testimonials': 'Depoimentos',
    'footer.privacy': 'Política de Privacidade',
    'footer.terms': 'Termos',
    'footer.language': 'Idioma',
    'footer.copyright': '© 2025 Kareem Taxi. Todos os direitos reservados.',
    'footer.viewOnGoogle': 'Veja-nos no Google',
    'footer.cadastro': 'Cadastro Motorista',
    'footer.recarga': 'Recarga Automática',
    
    // Contact basics
    'contact.title': 'Falar Connosco',
    'contact.name': 'Nome',
    'contact.email': 'Email',
    'contact.organization': 'Organização',
    'contact.subject': 'Assunto',
    'contact.message': 'Mensagem',
    'contact.submit': 'Enviar Mensagem',
    'contact.success': 'Obrigado! Responderemos por email.',
    'contact.emailLabel': 'Email',
    'contact.viewOnGoogle': 'Veja-nos no Google',
    
    // Partners
    'partners.title': 'Os Nossos Parceiros',
    'partners.subtitle': 'Parcerias constroem confiança através de resultados.',
    
    // 404 Page
    'notfound.intro': 'A página que procura não existe ou foi movida. Use os links abaixo para encontrar o que precisa:',
    'notfound.popularPages': 'Páginas Populares',
    'notfound.searchSuggestion': 'Se procura informações sobre cadastro Yango, registo motorista, ou requisitos, explore os links acima ou contacte a nossa equipa de suporte.',
    'notfound.needHelp': 'Precisa de Ajuda?',
    'notfound.contact': 'Contacte a nossa equipa de suporte no WhatsApp',
  }
};
